import { render, staticRenderFns } from "./TodayMenuContainer.vue?vue&type=template&id=2e09b229"
import script from "./TodayMenuContainer.vue?vue&type=script&lang=js"
export * from "./TodayMenuContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports